import * as React from 'react';
import Tour from 'reactour';
import {Button} from '@material-ui/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck} from '@fortawesome/free-solid-svg-icons'

import UsersAPI from 'api/users';

const getSteps = ({onComplete}) => [
    {
        selector: '#userSidebarMenu',
        content: 'This is your main menu here'
    }, {
        selector: '#myDashboardBroadcasterScheduledSurgeries',
        content: 'These are your upcoming surgeries you created'
    }, {
        selector: '#myDashboardBroadcasterOtherSurgeries',
        content: 'Surgeries scheduled by other broadcasters appear here'
    }, {
        selector: '#myDashboardBroadcasterSubscribers',
        content: 'You can see your new subscribers here'
    }, {
        selector: '#myDashboardScheduleNewButton',
        content: 'You can schedule a surgery broadcast by clicking on this button anytime'
    }, {
        selector: '#myDashboardBroadcasterShowTutorial',
        content: <div>
                <section>
                    You can go through this tutorial again any time by clicking on "Show tutorial"
                </section>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={onComplete}
                    style={{
                    color: '#fff',
                    marginTop: '20px',
                    padding: '5px 30px 5px 20px',
                    fontSize: '14px'
                }}>
                    <FontAwesomeIcon
                        icon={faCheck}
                        style={{
                        marginRight: '10px'
                    }}/>
                    Got it!</Button>
            </div>
    }
];

export default({isVisible, userProfile, onComplete}) => {
    const handleClose = async() => {
        try {
            await UsersAPI.updateTutorialSeenStatus(true);
            onComplete();
        } catch (err) {
            console.log('Problem updating tutorial seen status: ', err);
            // TODO: figure out how to handle this case
        } finally {
            onComplete();
        }
    }

    
    const visible = (isVisible || !userProfile.hasSeenTutorial)
    ? true
    : false;

    return visible && <Tour
        steps={getSteps({onComplete: handleClose})}
        accentColor="#0ca3d9"
        rounded={2}
        lastStepNextButton={null}
        isOpen={true}
        onRequestClose={handleClose}/>
}
